import { render, staticRenderFns } from "./studentPriceDetail.vue?vue&type=template&id=c38cb82e&scoped=true"
import script from "./studentPriceDetail.vue?vue&type=script&lang=js"
export * from "./studentPriceDetail.vue?vue&type=script&lang=js"
import style0 from "./studentPriceDetail.vue?vue&type=style&index=0&id=c38cb82e&prod&scoped=scoped&lang=css"
import style1 from "./studentPriceDetail.vue?vue&type=style&index=1&id=c38cb82e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38cb82e",
  null
  
)

export default component.exports